// https://github.com/Miragon/camunda-modeler-i18n-plugin/blob/develop/client/bpmnjs-i18n-extension/languages/de/properties-panel.js

/**
 * This file contains German translations for bpmn-js-properties-panel.
 */
export const propsPanel = {
    '[unknown template: {templateId}]': '[Unbekanntes Template: {templateId}]',
    '{label} must not contain whitespace':
        '{label} darf keine Leerzeichen enthalten',
    'A cycle defined as ISO 8601 repeating intervals format, or a cron expression.':
        'Ein Zyklus, definiert als ISO 8601 wiederholendes Intervallformat oder als Cron-Ausdruck.',
    'A cycle defined as ISO 8601 repeating intervals format.':
        'Ein Zyklus, definiert als ISO 8601 wiederholendes Intervallformat.',
    'A specific point in time defined as ISO 8601 combined date and time representation.':
        'Ein bestimmter Zeitpunkt, definiert als ISO 8601 kombinierte Datums- und Zeitdarstellung.',
    'A time duration defined as ISO 8601 durations format.':
        'Eine Zeitdauer, definiert als ISO 8601 Dauerformat.',
    'Activity Ref': 'Activity-Referenz',
    'Activity reference': 'Aktivitätsreferenz',
    'Add Constraint': 'Constraint hinzufügen',
    'Add Entry': 'Eintrag hinzufügen',
    'Add Property': 'Eigenschaft hinzufügen',
    'Add Value': 'Wert hinzufügen',
    After: 'Nach',
    All: 'Alle',
    'and ': 'und',
    Assignee: 'Bearbeiter',
    'Assignment type': 'Zuweisungstyp',
    assignment: 'Zuweisung',
    Assignment: 'Zuweisung',
    'Asynchronous after': 'Asynchron nach Ausführung',
    'Asynchronous After': 'Asynchron nach Ausführung',
    'Asynchronous before': 'Asynchron vor Ausführung',
    'Asynchronous Before': 'Asynchron vor Ausführung',
    'Asynchronous continuations': 'Asynchrone Fortsetzung',
    'Asynchronous Continuations': 'Asynchrone Fortsetzung',
    Before: 'Vor',
    Binding: 'Bindung',
    boolean: 'Boolescher Wert',
    BPMN: 'BPMN',
    'Business Key Expression': 'Ausdruck für Geschäftsschlüssel',
    'Business key expression': 'Ausdruck für Geschäftsschlüssel',
    'Business key': 'Geschäftsschlüssel',
    'Business rule task documentation':
        'Dokumentation zur Geschäftsregelaufgabe',
    'Call activity documentation': 'Dokumentation zur Aufrufaktivität',
    'CallActivity Type': 'Call-Activity-Typ',
    'Called decision': 'Aufgerufene Entscheidung',
    'Called element': 'Aufgerufenes Element',
    'Called Element': 'Aufgerufenes Element',
    'Camunda Form (embedded)': 'Camunda Formular (eingebettet)',
    'Camunda Form (linked)': 'Camunda Formular (verlinkt)',
    'Camunda Form': 'Camunda Form',
    'Camunda Forms': 'Camunda Forms',
    'Candidate groups': 'Kandidatengruppen',
    'Candidate Groups': 'Kandidatengruppen',
    'Candidate Starter Configuration': 'Konfiguration der Startkandidaten',
    'Candidate Starter Groups': 'Kandidatengruppen für den Start',
    'Candidate Starter Users': 'Kandidatenbenutzer für den Start',
    'Candidate starter users': 'Kandidatenbenutzer für den Start',
    'Candidate starter': 'Startkandidat',
    'Candidate users': 'Kandidatenbenutzer',
    'Candidate Users': 'Kandidatenbenutzer',
    'Case Ref': 'Fallreferenz',
    'Case ref': 'Fallreferenz',
    'Category Value': 'Kategoriebezeichnung',
    'Change element': 'Element ändern',
    Class: 'Klasse',
    CMMN: 'CMMN',
    'Code variable': 'Codevariable',
    Code: 'Code',
    Collection: 'Sammlung',
    Compensation: 'Kompensation',
    complete: 'Fertigstellen',
    'Completion condition': 'Abschlussbedingung',
    'Completion Condition': 'Abschlussbedingung',
    'Condition expression': 'Bedingungsausdruck',
    'Condition Expression': 'Bedingungsausdruck',
    'Condition Type': 'Bedingungstyp',
    Condition: 'Bedingung',
    'Conditions documentation': 'Dokumentation zu Bedingungen',
    Config: 'Konfiguration',
    'Configure Connector': 'Connector konfigurieren',
    'Connector Id': 'Konnektor-ID',
    'Connector ID': 'Konnektor-ID',
    'Connector inputs': 'Konnektor-Eingaben',
    'Connector outputs': 'Konnektor-Ausgaben',
    Connector: 'Konnektor-ID',
    Constraints: 'Einschränkungen',
    'Create a new local variable in the scope of this task. ':
        'Erstellen Sie eine neue lokale Variable im Rahmen dieser Aufgabe.',
    'Create new ...': 'Neu erstellen ...',
    create: 'erstellen',
    'Created in': 'Erstellt in',
    'Custom Fields for scope: ': 'Benutzerdefinierte Felder für den Bereich: ',
    'Custom Fields': 'Benutzerdefinierte Felder',
    'Custom Foo Group': 'Benutzerdefinierte Foo-Gruppe',
    'Custom form key': 'Benutzerdefinierter Formularschlüssel',
    'Custom type': 'Benutzerdefinierter Typ',
    'Customize how result variables are merged into the global scope of the process instance. ':
        'Passen Sie an, wie Ergebnisvariablen in den globalen Umfang der Prozessinstanz zusammengeführt werden.',
    Cycle: 'Zyklus',
    date: 'Datum',
    Date: 'Datum',
    'Decision ID': 'Entscheidungs-ID',
    'Decision Ref': 'Decision-Referenz',
    'Decision reference': 'Entscheidungsreferenz',
    'Default Value': 'Standard-Wert',
    'Default value': 'Standard-Wert',
    'Define a boolean condition expression that defines when this flow is taken. ':
        'Definieren Sie einen booleschen Bedingungsausdruck, der bestimmt, wann dieser Fluss genommen wird.',
    'Define an error code (e.g. ': 'Definieren Sie einen Fehlercode (z. B. ',
    'Define an input collection expression that defines the collection to iterate over (e.g. ':
        'Definieren Sie einen Eingabesammlungsausdruck, der die zu durchlaufende Sammlung definiert (z. B.',
    'Define the decision to evaluate and how to map back the evaluation result. ':
        'Definieren Sie die zu bewertende Entscheidung und wie das Bewertungsergebnis zurückgeführt wird. ',
    'Define the ID of the process to call (e.g. ':
        'Definieren Sie die ID des aufzurufenden Prozesses (z. B.',
    'Define the name of the message (e.g. ':
        'Definieren Sie den Namen der Nachricht (z. B.',
    'Define the name of the variable that will contain the error code.':
        'Definieren Sie den Namen der Variablen, die den Fehlercode enthält.',
    'Define the name of the variable that will contain the error message.':
        'Definieren Sie den Namen der Variablen, die die Fehlermeldung enthält.',
    'Define the name of the variable that will contain the escalation code.':
        'Definieren Sie den Namen der Variablen, die den Eskalationscode enthält.',
    'Define who the task is assigned to. One or all of the following attributes can be specified simultaneously. ':
        'Definieren Sie, wem die Aufgabe zugewiesen wird. Eines oder alle der folgenden Attribute können gleichzeitig angegeben werden.',
    'Delegate Class': 'Delegierte Klasse',
    'Delegate Expression': 'Delegierter Ausdruck',
    'Delegate expression': 'Delegierter Ausdruck',
    'Delegate Variable Mapping': 'Delegierte Variablenzuordnung',
    delete: 'löschen',
    deployment: 'Deployment',
    Details: 'Details',
    'DMN decision': 'DMN-Entscheidung',
    DMN: 'DMN',
    'Documentation: Timer events': 'Dokumentation: Zeitgesteuerte Ereignisse',
    'Documentation: Variable events': 'Dokumentation: Variablenereignisse',
    Documentation: 'Dokumentation',
    'Due date': 'Fälligkeitsdatum',
    'Due Date': 'Fälligkeitsdatum',
    Duration: 'Dauer',
    'Element documentation': 'Element-Dokumentation',
    'Element Documentation': 'Element-Dokumentation',
    'Element must have an unique id.': 'Element benötigt eine eindeutige ID',
    'Element Template': 'Element-Template',
    'Element Variable': 'Element-Variable',
    'Element variable': 'Elementvariable',
    'Embedded or External Task Forms':
        'Eingebettete oder externe Aufgabenformulare',
    end: 'Ende',
    enum: 'Aufzählung',
    'Error Code Variable': 'Fehler-Code-Variable',
    'Error Code': 'Fehler-Code',
    'Error event documentation': 'Fehlerereignis-Dokumentation',
    'Error Message Variable': 'Fehlermeldung-Variable',
    'Error Message': 'Fehlermeldung',
    'Error Name': 'Fehlername',
    Error: 'Fehler',
    Errors: 'Fehler',
    'Escalation Code Variable': 'Eskalationscode-Variable',
    'Escalation Code': 'Eskalationscode',
    'Escalation Name': 'Eskalationsbezeichnung',
    Escalation: 'Eskalation',
    'Evaluate a business rule, for example a DMN decision. To add a custom implementation, use a job worker. ':
        'Bewerten Sie eine Geschäftsregel, zum Beispiel eine DMN-Entscheidung. Um eine benutzerdefinierte Implementierung hinzuzufügen, verwenden Sie einen Job-Worker.',
    'Event type': 'Ereignistyp',
    'Event Type': 'Ereignistyp',
    'every 10 seconds, up to 5 times': 'Alle 10 Sekunden, bis zu 5 Mal',
    'every day, infinitely': 'Jeden Tag, unendlich',
    'every hour on the hour from 9-5 p.m. UTC Monday-Friday':
        'Jede Stunde zur vollen Stunde von 9-17 Uhr UTC Montag-Freitag',
    Exclusive: 'Exklusiv',
    Executable: 'Ausführbar',
    'Execute this task for each element of a given collection. ':
        'Führen Sie diese Aufgabe für jedes Element einer gegebenen Sammlung aus.',
    'Execution Listener': 'Ausführungs-Listener',
    'Execution listeners': 'Ausführungs-Listener',
    Expression: 'Ausdruck',
    'Extension properties': 'Erweiterungseigenschaften',
    Extensions: 'Erweiterungen',
    'External form reference': 'Externe Formularreferenz',
    'External resource': 'Externe Ressource',
    'External Resource': 'Externe Ressource',
    'External Task Configuration': 'Externe Task-Konfiguration',
    'External task': 'Externer Task',
    External: 'Extern',
    'FEEL expression': 'FEEL-Ausdruck',
    'Field Injection': 'Feldzuweisung',
    'Field injection': 'Feldzuweisung',
    'Field Injections': 'Feldzuweisungen',
    'Field injections': 'Feldzuweisungen',
    Fields: 'Felder',
    'Follow up date': 'Wiedervorlagedatum',
    'Follow Up Date': 'Wiedervorlagedatum',
    'Form Field': 'Formularfeld',
    'Form fields': 'Formularfelder',
    'Form Fields': 'Formularfelder',
    'Form ID': 'Formular-ID',
    'Form JSON configuration': 'Formular-JSON-Konfiguration',
    'Form Key': 'Formularschlüssel',
    'Form key': 'Formularschlüssel',
    'Form reference': 'Formularreferenz',
    Form: 'Formular',
    Format: 'Format',
    Forms: 'Formulare',
    General: 'Allgemein',
    'Generated Task Forms': 'Generierte Aufgabenformulare',
    'Global error reference': 'Globale Fehlerreferenz',
    'Global escalation reference': 'Globale Eskalationsreferenz',
    'Global message reference': 'Globale Nachrichtenreferenz',
    'Global signal reference': 'Globale Signalreferenz',
    'Group 1': 'Gruppe 1',
    'Group 2': 'Gruppe 2',
    'Group 3': 'Gruppe 3',
    'Group 4': 'Gruppe 4',
    Headers: 'Kopfzeilen',
    'History cleanup': 'Verlauf löschen',
    'History Configuration': 'History-Konfiguration',
    'History Time To Live': 'History-Aufbewahrungszeitraum',
    'How to configure a timer': 'Wie man einen Timer konfiguriert',
    'ID (process variable name)': 'ID (Prozessvariablen-Name)',
    'ID must be a valid QName.': 'ID muss ein gültiger QName sein.',
    'Id must be a valid QName.': 'ID muss ein gültiger QName sein',
    'ID must be unique.': 'ID muss eindeutig sein.',
    'ID must not be empty.': 'ID darf nicht leer sein.',
    'ID must not contain prefix.': 'ID darf kein Präfix enthalten.',
    'Id must not contain prefix.': 'ID darf kein Prefix enthalten',
    'ID must not contain spaces.': 'ID darf keine Leerzeichen enthalten.',
    'Id must not contain spaces.': 'ID darf keine Leerzeichen enthalten',
    Id: 'ID',
    ID: 'ID',
    'If turned on, all variables from the child process instance will be propagated to the parent process instance.':
        'Wenn aktiviert, werden alle Variablen der Kindprozessinstanz auf die Elternprozessinstanz übertragen.',
    'If turned on, all variables from the parent process instance will be propagated to the child process instance.':
        'Wenn aktiviert, werden alle Variablen der Elternprozessinstanz auf die Kindprozessinstanz übertragen.',
    'Implement a script task using an inline FEEL expression. To add a custom implementation, use a job worker. ':
        'Eine Skriptaufgabe unter Verwendung eines Inline-FEEL-Ausdrucks implementieren. Um eine benutzerdefinierte Implementierung hinzuzufügen, verwenden Sie einen Job-Worker.',
    'Implement a user task managed by Zeebe. To add a custom implementation, use a job worker. ':
        'Eine von Zeebe verwaltete Benutzeraufgabe implementieren. Um eine benutzerdefinierte Implementierung hinzuzufügen, verwenden Sie einen Job-Worker.',
    Implementation: 'Implementierung',
    'In mapping propagation': 'Weitergabe der Eingabezuordnung',
    'In mapping': 'Eingangszuordnung',
    'In Mapping': 'Eingangszuordnung',
    'In mappings': 'Eingangszuordnungen',
    Initiator: 'Initiator',
    'Inline script': 'Inline-Skript',
    'Inline Script': 'Inline-Skript',
    'Input collection': 'Eingabesammlung',
    'Input element': 'Eingabeelement',
    'Input mappings documentation': 'Dokumentation zu Eingabezuordnungen',
    'Input Parameter': 'Eingabeparameter',
    'Input Parameters': 'Eingabeparameter',
    'Input propagation': 'Weitergabe der Eingabedaten',
    'Input/Output': 'Eingabe/Ausgabe',
    Inputs: 'Eingaben',
    'Java class': 'Java-Klasse',
    'Java Class': 'Java-Klasse',
    'Job Configuration': 'Job-Konfiguration',
    'Job execution': 'Job-Ausführung',
    'Job Priority': 'Job-Priorität',
    'Job worker': 'Job-Worker',
    Key: 'Schlüssel',
    Label: 'Label',
    latest: 'Neueste',
    'Learn how to define conditions.':
        'Erfahren Sie, wie Bedingungen definiert werden.',
    'Learn more how to ': 'Erfahren Sie mehr darüber, wie ',
    'Learn more.': 'Erfahren Sie mehr.',
    'Link a form created with the Camunda Forms editor. To associate a custom form, application, or URL to the user task, specify an external reference. ':
        'Ein Formular verlinken, das mit dem Camunda Forms-Editor erstellt wurde. Um ein benutzerdefiniertes Formular, eine Anwendung oder URL der Benutzeraufgabe zuzuordnen, geben Sie eine externe Referenz an.',
    'Link Name': 'Link-Name',
    'Link or embed a form created with the Camunda Forms editor. To associate a custom form, application, or URL to the user task, specify a form key. ':
        'Ein Formular verlinken oder einbetten, das mit dem Camunda Forms-Editor erstellt wurde. Um ein benutzerdefiniertes Formular, eine Anwendung oder URL der Benutzeraufgabe zuzuordnen, geben Sie einen Formularschlüssel an.',
    Link: 'Link',
    'List values': 'Listenwerte',
    List: 'Liste',
    'Listener Id': 'Listener-ID',
    'Listener ID': 'Listener-ID',
    'Listener type': 'Listener-Typ',
    'Listener Type': 'Listener-Typ',
    Listeners: 'Listener',
    'Local variable name': 'Name der lokalen Variable',
    Local: 'Lokal',
    long: 'long',
    'Loop cardinality': 'Anzahl der Schleifendurchläufe',
    'Loop Cardinality': 'Anzahl der Schleifendurchläufe',
    'Map Decision Result': 'Entscheidungsergebnis zuordnen',
    'Map decision result': 'Entscheidungsergebnis abbilden',
    'Map entries': 'Zuordnungseinträge',
    Map: 'Zuordnung',
    'Mapping must have a {value}': 'Zuordnung muss einen {value} haben',
    'Mapping must have a target': 'Zuordnung muss ein Ziel haben',
    'Mapping must have a value': 'Zuordnung muss einen Wert haben',
    'Message event documentation': 'Dokumentation zu Nachrichtenereignissen',
    'Message Name': 'Nachrichtenname',
    'Message throw event documentation':
        'Dokumentation zu auslösenden Nachrichtenereignissen',
    'Message variable': 'Nachrichtenvariable',
    Message: 'Nachricht',
    'Multi Instance ': 'Mehrfachinstanz ',
    'Multi instance documentation': 'Dokumentation zu Mehrfachinstanzen',
    'Multi Instance': 'Mehrfachinstanz',
    'Multi-instance': 'Mehrfachinstanz',
    'Multiple elements are selected. Select a single element to edit its properties.':
        'Mehrere Elemente sind ausgewählt. Wählen Sie ein einzelnes Element aus, um dessen Eigenschaften zu bearbeiten.',
    'Must configure Connector': 'Muss Connector konfigurieren',
    'Must have max length {length}': 'Darf nicht länger sein als {length}',
    'Must have min length {length}': 'Darf nicht kürzer sein als {length}',
    'Must match pattern {pattern}': 'Muss dem Pattern {pattern} entsprechen',
    'Must not be empty': 'Darf nicht leer sein',
    'Must provide a value for timeout task listener':
        'Muss einen Wert für den Timeout-Task-Listener enthalten',
    'Must provide a value': 'Muss einen Wert enthalten',
    'Must provide either loop cardinality or collection':
        'Muss entweder Schleifen-Kardinalität oder Collection enthalten',
    'Name must not contain spaces': 'Name darf keine Leerzeichen enthalten',
    Name: 'Name',
    'Number of days before this resource is being cleaned up. If specified, takes precedence over the engine configuration.':
        'Anzahl der Tage, bevor diese Ressource bereinigt wird. Wenn angegeben, hat dies Vorrang vor der Engine-Konfiguration.',
    Off: 'Aus',
    On: 'An',
    'option A': 'Option A',
    'option B': 'Option B',
    'option C': 'Option C',
    'Otherwise, only variables defined via input mappings will be propagated.':
        'Andernfalls werden nur über Eingabe-Mappings definierte Variablen propagiert.',
    'Otherwise, only variables defined via output mappings will be propagated.':
        'Andernfalls werden nur über Ausgabe-Mappings definierte Variablen propagiert.',
    'Out mapping propagation': 'Weitergabe des Ausgabe-Mappings',
    'Out Mapping': 'Ausgabe-Mapping',
    'Out mappings': 'Ausgabe-Mappings',
    'Output collection': 'Ausgabesammlung',
    'Output element': 'Ausgabeelement',
    'Output mappings documentation': 'Dokumentation zu Ausgabe-Mappings',
    'Output Parameter': 'Ausgabeparameter',
    'Output Parameters': 'Ausgabeparameter',
    'Output propagation': 'Ausgabeweitergabe',
    Outputs: 'Ausgaben',
    'Parameter must have a name': 'Parameter muss einen Namen haben',
    Parameters: 'Parameter',
    'Participant Name': 'Name des Teilnehmers',
    'Participant ID': 'Teilnehmer-ID',
    Priority: 'Priorität',
    'Process documentation': 'Prozessdokumentation',
    'Process Documentation': 'Prozessdokumentation',
    'Process Id': 'Prozess-ID',
    'Process ID': 'Prozess-ID',
    'Process name': 'Prozessname',
    'Process Name': 'Prozessname',
    'Process variable name': 'Prozess-Variablenname',
    'Process variables': 'Prozessvariablen',
    'Propagate all child process variables':
        'Alle Kindprozessvariablen propagieren',
    'Propagate all parent process variables':
        'Alle Elternprozessvariablen propagieren',
    'Propagate all variables': 'Alle Variablen propagieren',
    Properties: 'Eigenschaften',
    'Receive task documentation': 'Dokumentation zur Empfangsaufgabe',
    'Refers to the process variable name':
        'Bezieht sich auf den Namen der Prozessvariablen',
    Resource: 'Ressource',
    'Result variable': 'Ergebnisvariable',
    'Result Variable': 'Ergebnisvariable',
    Retries: 'Wiederholungsversuche',
    'Retry Time Cycle': 'Wiederholungszyklus',
    'Retry time cycle': 'Wiederholungszyklus',
    Scope: 'Gültigkeitsbereich',
    'Script Format': 'Skriptformat',
    'Script task documentation': 'Dokumentation zur Skriptaufgabe',
    'Script type': 'Skripttyp',
    'Script Type': 'Skripttyp',
    Script: 'Skript',
    'Select an element to edit its properties.':
        'Wählen Sie ein Element aus, um dessen Eigenschaften zu bearbeiten.',
    'Send task documentation': 'Dokumentation zur Sendaufgabe',
    'send ': 'senden',
    'Service task documentation': 'Dokumentation zur Serviceaufgabe',
    'Set color': 'Farbe festlegen',
    'Set Color': 'Farbe festlegen',
    'Signal Name': 'Signalname',
    Signal: 'Signal',
    'Source expression': 'Quellausdruck',
    'Source Expression': 'Quellausdruck',
    Source: 'Quelle',
    'Specify more than one group as a comma separated list. ':
        'Geben Sie mehr als eine Gruppe kommagetrennt an.',
    'Specify more than one user as a comma separated list. ':
        'Geben Sie mehr als einen Benutzer als kommagetrennte Liste an.',
    'Specify more than one variable change event as a comma separated list . Variable change events are:':
        'Geben Sie mehr als ein Variablenänderungsereignis als kommagetrennte Liste an. Variablenänderungsereignisse sind:',
    'Specify more than one variable change event as a comma separated list. ':
        'Geben Sie mehr als ein Variablen-Change-Event kommagetrennt an.',
    'Specify which job workers handle the event work. ':
        'Geben Sie an, welche Job-Worker die Ereignisarbeit übernehmen.',
    'Specify which job workers handle the task work to evaluate business rules. ':
        'Geben Sie an, welche Job-Worker die Aufgabenarbeit zur Bewertung von Geschäftsregeln übernehmen.',
    'Specify which job workers handle the task work to execute a script. ':
        'Geben Sie an, welche Job-Worker die Aufgabenarbeit zur Ausführung eines Skripts übernehmen.',
    'Specify which job workers handle the task work to execute a service (e.g. ':
        'Geben Sie an, welche Job-Worker die Aufgabenarbeit zur Ausführung eines Dienstes übernehmen (z. B.',
    'Specify which job workers handle the task work to send a message (e.g. ':
        'Geben Sie an, welche Job-Worker die Aufgabenarbeit zum Senden einer Nachricht übernehmen (z. B.',
    'Start initiator': 'Startinitiator',
    'Start typing "${}" to create an expression.':
        'Beginnen Sie mit der Eingabe von "${}", um einen Ausdruck zu erstellen.',
    start: 'starten',
    Startable: 'Kann gestartet werden',
    'String or expression': 'Zeichenkette oder Ausdruck',
    string: 'Zeichenkette',
    String: 'Zeichenkette',
    'Subscription correlation key': 'Abonnement-Korrelationsschlüssel',
    take: 'durchführen',
    'Target must not contain whitespace':
        'Ziel darf keine Leerzeichen enthalten',
    Target: 'Ziel',
    'Task definition': 'Aufgabendefinition',
    'Task listener': 'Aufgaben-Listener',
    'Task Listener': 'Aufgaben-Listener',
    'Task listeners': 'Aufgaben-Listener',
    'Task Priority': 'Aufgabenpriorität',
    'Tasklist Configuration': 'Tasklisten-Konfiguration',
    Tasklist: 'Taskliste',
    'Tenant ID': 'Mandanten-ID',
    'Tenant Id': 'Tenant-ID',
    Text: 'Text',
    'The due date as an EL expression (e.g. ${someDate} or an ISO date (e.g. 2015-06-26T09:54:00)':
        'Das Fälligkeitsdatum als EL-Expression (z.B. ${someDate}) oder als ISO-Datum (z.B. 2015-06-26T09:54:00)',
    'The due date as an EL expression (e.g. ${someDate}) or an ISO date (e.g. 2015-06-26T09:54:00).':
        'Das Fälligkeitsdatum als EL-Ausdruck (z. B. ${someDate}) oder als ISO-Datum (z. B. 2015-06-26T09:54:00).',
    'The number of times the engine tries executing this activity if a worker signals a failure. The default is three.':
        'Die Anzahl der Versuche, die die Engine unternimmt, um diese Aktivität auszuführen, wenn ein Worker einen Fehler signalisiert. Standard ist drei.',
    'This maps to the process definition key.':
        'Dies entspricht dem Prozessdefinitionsschlüssel.',
    'Throw expression': 'Ausnahmeausdruck',
    'Time to live': 'Lebensdauer',
    timeout: 'Zeitlimit',
    'Timer Definition Type': 'Timer-Definitionstyp',
    'Timer Definition': 'Timer-Definition',
    'Timer documentation': 'Timer-Dokumentation',
    Timer: 'Timer',
    'To collect the output define the output collection and the output element expressions. ':
        'Um die Ausgabe zu sammeln, definieren Sie die Ausgabesammlung und die Ausgabeelementausdrücke.',
    Topic: 'Nachrichtenkanal (Topic)',
    Type: 'Typ',
    update: 'aktualisieren',
    'User assignment': 'Benutzerzuweisung',
    'User task documentation': 'Dokumentation zur Benutzeraufgabe',
    'User task form documentation':
        'Dokumentation zum Benutzeraufgabenformular',
    'UTC plus 2 hours zone offset': 'UTC plus 2 Stunden Zeitzonenverschiebung',
    'UTC time': 'UTC-Zeit',
    Validation: 'Validierung',
    Value: 'Wert',
    Values: 'Werte',
    'Variable assignment value': 'Wert der Variablenzuweisung',
    'Variable Event': 'Variablenereignis',
    'Variable events': 'Variablenereignisse',
    'Variable name': 'Variablenname',
    'Variable Name': 'Variablenname',
    Variables: 'Variablen',
    'Version Tag': 'Versions-Tag',
    'version tag': 'Versions-Tag',
    'Version tag': 'Versions-Tag',
    version: 'Version',
    Version: 'Version',
    versionTag: 'Versions-Tag',
    'Wait for completion': 'Auf Fertigstellung warten',
    'Wait for Completion': 'Auf Fertigstellung warten',
    'Zeebe user task': 'Zeebe-Benutzeraufgabe',
} as const;
